import React, { useState, useEffect, useRef } from 'react';
import '../Style/Chatbot.css';

const Chatbot = ({ onClose }) => {
  const [input, setInput] = useState('');
  const [chatLog, setChatLog] = useState([]);
  const [loading, setLoading] = useState(false);
  const chatEndRef = useRef(null);

  // Auto scroll to bottom when messages update
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chatLog, loading]);

  const sendMessage = async () => {
    const currentInput = input.trim();
    if (!currentInput) return;

    const userMessage = { sender: 'user', text: currentInput };
    setChatLog((prev) => [...prev, userMessage]);
    setInput('');
    setLoading(true);

    try {
      const res = await fetch('/api/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message: currentInput }),
      });

      const data = await res.json();

      if (!res.ok) {
        const errorMsg = data.message || data.error || 'Something went wrong';
        setChatLog((prev) => [
          ...prev,
          { sender: 'bot', text: `Error: ${errorMsg}` },
        ]);
        return;
      }

      const botMessage = { sender: 'bot', text: data.reply || 'No reply' };
      setChatLog((prev) => [...prev, botMessage]);
    } catch (error) {
      setChatLog((prev) => [
        ...prev,
        {
          sender: 'bot',
          text: 'Error: Unable to connect to the assistant. Please try again.',
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter' && !loading) {
      sendMessage();
    }
  };

  return (
    <div className="chatbot-container">
      {/* Header with Close Button */}
      <div className="chatbot-header">
        <span>Assistant</span>
        <button className="chatbot-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      {/* Chat Messages */}
      <div className="chatbot-messages">
        {chatLog.map((msg, idx) => (
          <div key={idx} className={`message-row ${msg.sender}`}>
            <span className={`message-bubble ${msg.sender}`}>{msg.text}</span>
          </div>
        ))}

        {loading && (
          <div className="message-row bot">
            <span className="message-bubble bot">...</span>
          </div>
        )}

        <div ref={chatEndRef} />
      </div>

      {/* Input Box */}
      <div className="chatbot-input-row">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleEnter}
          placeholder="Type your message..."
          className="chatbot-input"
          disabled={loading}
        />

        <button onClick={sendMessage} className="send-button" disabled={loading}>
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;